/* es6-map/lib/iterator-kinds */ function _(require, module, exports) {
    module.exports = require(353) /* es5-ext/object/primitive-set */('key', 'value', 'key+value');
}
